const listaDeUsuarios = (state) => {
    return state.items || [];
}

const loadingUsuario = (state) => {
    return state.buscando
}

const listaGrupos = (state) => {
    return state.grupos
}

const grupoSelecionadoComRotas = (state) => {
    return state.selecionado
}

export {
    listaDeUsuarios,
    loadingUsuario,
    listaGrupos,
    grupoSelecionadoComRotas
}